export const CANCEL_TOKENS = {
  UPLOAD_VIDEO: (fileName: string) => `UPLOAD_VIDEO_${fileName}`,
};
